export default "__VITE_ASSET__CGlC3OP3__"